import Toggle from '../toggle/toggle.js';
import ToggleOver from '../toggle/toggle-over.js';
import Current from './current.js';
import { Typography } from '../animations';
import { SCROLL } from '../app.config.js';
import BreakPoints from '../shared/_breakpoints.js';
import gsap from '@gsap/business';
import { ScrollTrigger } from '@gsap/business/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

import "splitting/dist/splitting.css";
import "splitting/dist/splitting-cells.css";
export default class Nav extends BreakPoints {

	constructor(node, scroller) {
    super();
		this.node = node;
		this.scroller = scroller;

		this.selectors = {
			mainWrapper: 'body',
			mobileToggle: '[data-nav-toggle]',
			serviceToggle: '[data-service-toggle]',
			mainNav: {
				attribute: '[data-nav-btn]',
				target: '[data-nav-target]',
				overArea: '[data-nav-area]'
			},
			mobileNav: {
				attribute: '[data-mobilenav-btn]',
				target: '[data-mobilenav-target]',
			},
			search: {
				attribute: '[data-search-btn]',
				target: '[data-search-target]'
			},
      noScrollLayer: '[data-scroll-blocker]'
		}

		this.settings = {
			activeClass: 'active',
			wrapperClass: 'mobile-nav-open',
      navOpen: '_main-nav'
		}

    this.wrapper = document.querySelector(this.selectors.mainWrapper);

		this.init();
		this.addListener();
	}

	init() {
		const currentWrapper = this.node.querySelector('[data-current]');
    if(currentWrapper) {
      new Current(currentWrapper);
      Typography.split(currentWrapper);
    }

		this.mainNav = Toggle.init(
			this.selectors.mainNav.attribute,
			this.selectors.mainNav.target,
			this.node,
			this.settings.activeClass,
      // this.selectors.mainNav.overArea,
      this.callback.bind(this)
		);

    // mobile sub nav
		this.mobileNavs = Toggle.init(
			this.selectors.mobileNav.attribute,
			this.selectors.mobileNav.target,
			this.node,
			this.settings.activeClass
		);

    //various
    this.mobileToggle = document.querySelector(this.selectors.mobileToggle);
    this.noScrollLayer = document.querySelector(this.selectors.noScrollLayer);
    this.searchToggles = Array.from(document.querySelectorAll('[data-nav-btn="nav-search"]'));

    if (this.currentMq.name === 'md' || this.currentMq.name === 'lg') {
      this.isMediaQueryLg = true;
    } else {
      this.isMediaQueryLg = false;
    }
	}

	addListener() {
    this.mobileToggle && this.mobileToggle.addEventListener('click', this.onToggle.bind(this));
    this.noScrollLayer && this.noScrollLayer.addEventListener('click', this.onToggle.bind(this));
    this.searchToggles && this.searchToggles.forEach(searchToggle => {
      searchToggle.addEventListener('click', this.onSearchToggle.bind(this));
    })
	}

  callback({type, item}) {
    switch (type) {
      case 'add':
        this.addClassHandler(item)
        break;
      case 'remove':
        this.removeClassHandler(item)
        break;
    }
  }

  addClassHandler() {
    if (this.isMediaQueryLg) {
      this.wrapper.classList.add(this.settings.navOpen);
      this.noScrollLayer.classList.add('_dark');
      SCROLL && this.scroller.stop();
    }
  }

  removeClassHandler() {
    if (this.isMediaQueryLg) {
      this.wrapper.classList.remove(this.settings.navOpen);
      this.noScrollLayer.classList.remove('_dark');
      SCROLL && this.scroller.start();
    }
  }

  toggleScroll() {
    if(this.wrapper.classList.contains(this.settings.navOpen)) {
      this.wrapper.classList.remove(this.settings.navOpen)
      SCROLL && this.scroller.start();
      ScrollTrigger.normalizeScroll(true)
    } else {
      this.wrapper.classList.add(this.settings.navOpen)
      SCROLL && this.scroller.stop();
      ScrollTrigger.normalizeScroll(false)
    }
  }

  onToggle() {
		//toggle various classes to open/close mobile nav
		this.mobileToggle.classList.toggle(this.settings.activeClass);
		this.node.classList.toggle(this.settings.activeClass);

    this.toggleScroll();

    //fix search active mobile/desktop classes for scroll blocker
    if(!this.isMediaQueryLg) {
      if (this.wrapper.classList.contains('_search-active')) {
        this.wrapper.classList.remove('_search-active');
        const header = this.wrapper.querySelector('header');
        header.classList.add('active')
        this.wrapper.classList.add(this.settings.navOpen);
      }
    } else {
      if (this.wrapper.classList.contains('_search-active')) {
        this.wrapper.classList.remove('_search-active');
        this.wrapper.classList.remove(this.settings.navOpen);
      }
    }

		//reset all buttons
		this.resetAll(this.mainNav);
	}

  onSearchToggle() {
    const headerToggler = this.wrapper.querySelector(this.selectors.mobileToggle);
    const header = this.wrapper.querySelector('header')

    if(this.wrapper.classList.contains('_search-active')) {
      this.wrapper.classList.remove('_search-active');
      this.noScrollLayer.classList.remove('active');
      SCROLL && this.scroller.start();
    } else {
      this.wrapper.classList.add('_search-active');
      this.noScrollLayer.classList.add('active');
      SCROLL && this.scroller.stop();
    }
    if (this.wrapper.classList.contains(this.settings.navOpen)) {
      this.wrapper.classList.remove(this.settings.navOpen);
      headerToggler.classList.remove('active');
      header.classList.remove('active');
    }
  }

	resetAll(items) {
		items.forEach(item => {
			item.target.classList.remove(this.settings.activeClass);
			item.target.removeAttribute('aria-expanded');
		});
	}
}
